import { render, staticRenderFns } from "./MobileAppDeveloper.vue?vue&type=template&id=f7a80774&scoped=true"
var script = {}
import style0 from "./MobileAppDeveloper.vue?vue&type=style&index=0&id=f7a80774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a80774",
  null
  
)

export default component.exports